import { connect } from 'react-redux';
import * as RX from 'reactxp';
import ButtonLink from '../../components/button_link';
import OutlineBox from '../../components/outline_box';
import * as ReactGA from '../../modules/google_analytics';
import { openUrl } from '../../modules/links/index';
import { Window } from '../../reducers/window';
import { applyBreakpoints, md  } from '../../utils/breakpoints';
import t from '../../utils/i18n';
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, h1, h2, subHeader } from '../../utils/styles';

interface EmergencyDepartmentProps {
  window: Window & { multiplier: number };
};

const styles = (multiplier) => ({
  header: RX.Styles.createTextStyle({
    color: colors.header,
    marginBottom: 12 * multiplier,
    textAlign: 'left',
  }),
  image: RX.Styles.createImageStyle({
    height: 250 * multiplier,
    marginBottom: 12 * multiplier
  }),
  information: RX.Styles.createViewStyle({
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  label: RX.Styles.createTextStyle({
    color: colors.black,
    marginBottom: 8 * multiplier
  }),
  link: RX.Styles.createLinkStyle({
    color: colors.primary,
    textDecorationLine: 'underline',
  }),
  sectionHeader: RX.Styles.createTextStyle({
    marginBottom: 12 * multiplier,
  }),
  subHeader: RX.Styles.createTextStyle({
    marginBottom: 12 * multiplier,
  }),
});

export const getAddress = ({ streetAddress1, streetAddress2, city, state, zipCode }: any) => [
  streetAddress1 && `${streetAddress1} `,
  streetAddress2 && `${streetAddress2} `,
  city && `${city}, `,
  state && `${state} `,
  zipCode && `${zipCode}`,
].join('');

// for futre when there are multiple ED's displayed with end point call
const emergencyDepartments = [
  {
    city: 'Lancaster',
    image: 'TBD',
    name: 'Lancaster General Hospital',
    phoneNumber: '717-544-5511',
    state: 'PA',
    streetAddress1: '555 North Duke Street',
    zipCode: '17602',
  }
];

class EmergencyDepartment extends RX.Component<EmergencyDepartmentProps, RX.Stateless> {

  constructor(props: EmergencyDepartmentProps) {
    super(props);
  }

  public componentDidMount() {
    ReactGA.trackEvent(
      'Go to Emergency Department',
      'Navigation',
    );
  }

  public render() {
    const { window: { width, multiplier } } = this.props;

    return (
      <RX.View>
        <RX.Text style={[h1(multiplier), styles(multiplier).header]}>{t('emergencyDepartment.header')}</RX.Text>
        <RX.Text style={[body(multiplier), styles(multiplier).subHeader]}>
          {t('emergencyDepartment.subheader')}
        </RX.Text>
        {emergencyDepartments.map((ed) =>
          <OutlineBox key={ed.name}>
            <RX.Image
              style={[
                styles(multiplier).image,
                ...applyBreakpoints(width, { md: { height: 330 }})
              ]}
              resizeMode='cover'
              source={
                width > md
                ? require('../../assets/hero_ED.png')
                : require('../../assets/emergency_department.jpg')
              }
            />
            <RX.Text style={[h2(multiplier), styles(multiplier).sectionHeader]}>{ed.name}</RX.Text>
            <RX.View style={styles(multiplier).information}>
              <RX.View style={{ width: (width > 1200 ? 1200 : width  - 64 * multiplier)  }}>
                <RX.Link
                  style={[body(multiplier), styles(multiplier).link]}
                  onPress={() => {
                    openUrl(`https://www.google.com/maps/place/${encodeURIComponent(getAddress(ed))}`, '_blank')
                  }}
                  url={`https://www.google.com/maps/place/${encodeURIComponent(getAddress(ed))}`}
                >
                  <RX.Text>
                    {ed.streetAddress1}
                  </RX.Text>
                </RX.Link>
                <RX.Link
                  style={[body(multiplier), styles(multiplier).link]}
                  onPress={() => {
                    openUrl(`https://www.google.com/maps/place/${encodeURIComponent(getAddress(ed))}`, '_blank')
                  }}
                  url={`https://www.google.com/maps/place/${encodeURIComponent(getAddress(ed))}`}
                >
                  <RX.Text>
                    {`${ed.city}, ${ed.state} ${ed.zipCode} ${width}`}
                  </RX.Text>
                </RX.Link>
                <RX.Link
                  style={
                    [body(multiplier), styles(multiplier).link,
                      { height: 20 * multiplier, textDecorationLine: 'none', marginTop: 50 }]}
                  url='tel:717-544-5511'>{t('emergencyDepartment.phone')} {ed.phoneNumber}
                </RX.Link>
                <ButtonLink
                  dark
                  external
                  destination={`https://www.google.com/maps/place/${encodeURIComponent(getAddress(ed))}`}
                  text={t('emergencyDepartment.getDirections')}
                />
              </RX.View>
            </RX.View>
          </OutlineBox>)}
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(EmergencyDepartment);



// WEBPACK FOOTER //
// ./src/pages/emergency_department/index.tsx